export enum CompareAtPriceBaseType
{
    Price,
    Cost
}